import { useWidgetDndContextData } from "src/context/WidgetDndContext";
import { HEADING_TYPE_IMAGE, IS_TEXT_ON_IMAGE } from "../constant";
import { getHeadingStyle } from "../utils";
import { isMobileDevice } from "src/components/WidgetMaker/WidgetDnD/isMobileDevice";
import { COMMON_LAYOUT_TYPE } from "../../ListPresentation/components/Testimonials/Constants";
import { RICH_TEXT_IMAGE } from "src/constants/builderConstants";
import { twMerge } from "tailwind-merge";
import { useSelector } from 'react-redux';

function FilterHeading(props) {
  const { isCollection, selectedCatCol } = props;
  const {
    widgetContextState: { pageStyle },
  } = useWidgetDndContextData();
  const { catalog_items } = useSelector((state: any) => ({
    catalog_items: state.catalogReducer.catalog_items,
  }));
  const isMobile = isMobileDevice();
  const currentWidgetType = isCollection ? pageStyle?.caligraphyCollection : pageStyle?.caligraphyCategory;
  const currentHeadingType = currentWidgetType?.heading_type
  const isBannerFullWidth = currentWidgetType?.isBannerFullWidth;
  const imageOverlay = currentWidgetType?.overlay;
  const textPostion = currentWidgetType?.text_placement === IS_TEXT_ON_IMAGE;
  const isFullWidthHeading = pageStyle?.sortAndFilter?.layout_desktop !== COMMON_LAYOUT_TYPE.ONE;
  const textAlignment = currentWidgetType?.text_alignment;
  const bannerImageHeight = isMobile ? 240 : currentWidgetType.height;

  function renderImageHeading() {
    return (
      <>
        <div
          style={{
            margin: isBannerFullWidth
              ? isMobile
                ? '0 -1rem'
                : '0'
              : isMobile
                ? '0'
                : '0 1rem',
            height: bannerImageHeight,
          }}
          className={`tw-relative ${!isMobile ? 'tw-pb-[20px]' : ''} ${!isBannerFullWidth && isMobile ? '!tw-mt-[16px]' : ''}`}
        >
          <img
            src={selectedCatCol?.data?.image_url || RICH_TEXT_IMAGE}
            height={bannerImageHeight}
            className="tw-object-cover"
            width={'100%'}
          />
          {textPostion && <div>{renderTextHeading(true)}</div>}
          <div
            className={`tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-[1] tw-bg-black tw-pb-[20px]`}
            style={{
              background: `rgba(0,0,0, ${(imageOverlay || 1) / 100 || 0.2})`,
              height: bannerImageHeight,
            }}
          ></div>
        </div>
      </>
    )
  }

  function renderTextHeading(isTextOnImage = false) {
    const selectedIdProductCount = catalog_items?.[selectedCatCol?.data?.id]?.length || 0;
    return (
      <div
        style={{
          ...getHeadingStyle(currentWidgetType, isMobile),
          margin: !isTextOnImage && isMobile ? '0 -1rem' : '',
        }}
        className={`${isFullWidthHeading && !isTextOnImage ? `tw-flex tw-flex-col tw-justify-center tw-border-b tw-border-solid tw-border-[#111c3629] ${!isMobile ? 'tw-min-h-[108px]' : ''} ${textAlignment === 'left' ? `tw-items-start tw-pl-[56px]}` : 'tw-text-center'}` : ''}
         ${isTextOnImage ? `tw-absolute tw-top-[0px] !tw-z-20  tw-flex tw-h-[100%]  tw-w-[100%] tw-flex-col tw-justify-center ${textAlignment === 'left' ? `tw-items-start ${isMobile ? 'tw-pl-[24px]' : 'tw-pl-[56px]'}` : 'tw-text-center'}` : ''}
        `}
      >
        <div
          className={twMerge(
            `${!isFullWidthHeading && isMobile ? 'tw-border-b tw-border-solid tw-border-[#111c3629] tw-py-[24px]' : ''}`,
            `${!isTextOnImage && isMobile ? 'tw-px-[16px]' : ''}`
          )}
        >
          <h1 style={getHeadingStyle(currentWidgetType, isMobile)}>{selectedCatCol?.data?.name || 'COLLECTION'}</h1>
          {!isTextOnImage && !isMobile && !!selectedIdProductCount && (
            <span className="tw-ml-8 tw-text-[13px] tw-font-normal tw-text-newBlack tw-opacity-70">
              (
              {`${selectedIdProductCount} ${selectedIdProductCount > 1 ? 'products' : 'product'}`}
              )
            </span>
          )}
        </div>
      </div>
    )
  }

  return (
    currentHeadingType === HEADING_TYPE_IMAGE ? renderImageHeading() : renderTextHeading()
  )
}

export default FilterHeading